export const hasPermission = (permissions, moduleName, action = "view") => {
  if (!Array.isArray(permissions) || !moduleName) return false;

  const modulePermission = permissions.find(
    (p) => p.module === moduleName || p.key === moduleName
  );

  if (!modulePermission) return false;

  // Admin API format: { key, actions: [{ key, selected }] }
  if (Array.isArray(modulePermission.actions)) {
    const actionEntry = modulePermission.actions.find((a) => a.key === action);
    return actionEntry?.selected === true;
  }

  // Employer / employee format: { module, enabled, view, create, ... }
  if (!modulePermission.enabled) return false;
  return modulePermission[action] === true;
};
